import { ERROR_TEXT_GEO, ERROR_TEXT_GEO_DEFAULT } from 'constants/messages'

import { Button } from '@pbe/react-yandex-maps'
import getLocationIcon from 'assets/icons/getLocationIcon.svg'
import { yandexMap } from 'feature/addresses/redux/addressCreateSelector'
import { getSuggestsQueryByCoords } from 'feature/DaData/getSuggestsQueryByCoords'
import { getUserGeolocation } from 'feature/YandexMap/lib/getUserGeolocation'
import { useSetNotice } from 'hooks/useSetNotice'
import { FC, useEffect, useState } from 'react'
import { useActions, useAppSelector, useThunkDispatch } from 'store/hooks'
import { Severity } from 'widget/Notifications'

import { goToCoordinates } from '../redux/actions/goToCoordinates'
import { AddressErrorsType } from 'feature/addresses/types'

// контроллер для карты (геолокация пользователя)
export const GeolocationControlUnit: FC = () => {
  const [wasClick, setWasClick] = useState(false)
  const setNotice = useSetNotice()
  const { userGeo, setting } = useAppSelector(yandexMap)

  const geolocationSetting = setting.geolocation

  const thunkDispatch = useThunkDispatch()
  const {
    setUserGeo,
    setIsValidAddress,
    setInputAddressSuggest,
    setInputAddress,
    setIsCanceledClick,
    setIsError,
    setIsDirtyAddress,
    setErrorMessage,
  } = useActions()

  const getUserGeoError = (err: GeolocationPositionError) => {
    const errorText = err.code === 1 ? ERROR_TEXT_GEO : ERROR_TEXT_GEO_DEFAULT
    setNotice(errorText, Severity.error)
    setUserGeo({ address: null })
  }

  const successGetGeoFunction = async (
    position?: GeolocationPosition | undefined,
  ) => {
    if (!position) return

    setUserGeo({ geolocation: position.coords })
    setIsCanceledClick(true)
    thunkDispatch(goToCoordinates({ position }))
    setIsDirtyAddress(true)
  }

  useEffect(() => {
    if (!userGeo.geolocation || !window.map || !wasClick) return
    if (!geolocationSetting.changeInput) return

    getSuggestsQueryByCoords(
      `${userGeo.geolocation.latitude}`,
      `${userGeo.geolocation.longitude}`,
    ).then(res => {
      const suggest = res.data[0]
      if (!suggest?.address) return

      setInputAddress(suggest.address)
      setInputAddressSuggest(suggest)
      setUserGeo({
        address: suggest,
        coords:
          suggest.geoLat && suggest.geoLon
            ? [+suggest.geoLat, +suggest.geoLon]
            : null,
      })

      if (suggest.address.length <= 4) {
        setErrorMessage(AddressErrorsType.addressNotFound)
        setIsError(true)
        return
      }

      setIsDirtyAddress(true)
      setIsError(false)
      setErrorMessage('')
      setIsValidAddress(true)
    })
  }, [userGeo.geolocation])

  return (
    <Button
      options={{ maxWidth: 128, selectOnClick: false }}
      data={{
        image: getLocationIcon,
        title: 'Определить ваше местоположение',
      }}
      onClick={() => {
        setWasClick(true)
        getUserGeolocation({
          successFunction: successGetGeoFunction,
          errorFunction: getUserGeoError,
        })
      }}
    />
  )
}
